import axiosInstance from "auth/FetchInterceptor";
import {
  EMAIL_SENDER_SEARCH_GRID,
  EMAIL_SENDER_CREATE,
  EMAIL_SENDER_UPDATE,
  EMAIL_SENDER_DELETE,
} from "constants/ApiConstant";

const EmailSenderService = {};

EmailSenderService.getEmailSender = function (data) {
  return axiosInstance.post(EMAIL_SENDER_SEARCH_GRID, data);
};

EmailSenderService.createEmailSender = function (data) {
  return axiosInstance.post(EMAIL_SENDER_CREATE, data);
};

EmailSenderService.updateEmailSender = function (data) {
  return axiosInstance.post(EMAIL_SENDER_UPDATE, data);
};

EmailSenderService.delEmailSender = function (id) {
  return axiosInstance.delete(`${EMAIL_SENDER_DELETE}/${id}`);
};

export default EmailSenderService;